import {
  getSectionItemReferences,
  type StatementItemReference,
} from "@/payroll/ai-script/statement/statement-item-reference";
import {
  BLOCK_TYPE,
  type PayStatement,
} from "@/payroll/ai-script/statement/statement-schema";

/**
 * Builds the same question targets that StatementRenderer puts beside PayPack
 * figures. Managers can therefore select only a value that the technician can
 * identify in the rendered pack.
 */
export const getStatementItemReferences = (
  statement: PayStatement | null | undefined,
): StatementItemReference[] => {
  if (!statement) return [];

  return statement.blocks.flatMap<StatementItemReference>((block) => {
    switch (block.type) {
      case BLOCK_TYPE.summary:
        return (block.metrics ?? [])
          .filter((metric) => metric.label)
          .map((metric) => ({
            line: metric.label ?? undefined,
            amount: metric.value,
          }));
      case BLOCK_TYPE.section:
        return getSectionItemReferences(block);
      case BLOCK_TYPE.keyValue:
        return block.rows
          .filter((row) => row.label)
          .map((row) => ({
            heading: block.heading,
            line: row.label ?? undefined,
            amount: row.value,
          }));
      case BLOCK_TYPE.totals:
        return block.items.map((item) => ({
          heading: block.label,
          line: item.label ?? undefined,
          amount: item.value,
        }));
      case BLOCK_TYPE.note:
      case BLOCK_TYPE.divider:
        return [];
    }
  });
};
